module.exports = __webpack_public_path__ + "img/device-2@2x.9683a5b4.webp";